// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".whjVDHxaSZUCdZ-rh65kLw\\=\\= > * {\n  text-align: center;\n}\n\n._3v-z4Ccex2hQZHvDpE6MrQ\\=\\= {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n", "",{"version":3,"sources":["webpack://./src/dashboard/styles/CourseCatalogDialog.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ","sourcesContent":[".dialogTitle > * {\n  text-align: center;\n}\n\n.iconButton {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogTitle": "whjVDHxaSZUCdZ-rh65kLw==",
	"iconButton": "_3v-z4Ccex2hQZHvDpE6MrQ=="
};
export default ___CSS_LOADER_EXPORT___;
